import type { Table } from "@tanstack/react-table";

import type { FileItem } from "../../types";

import { TableHeader, TableRow } from "./components";

type FilesListViewProps = {
  isLoading: boolean;
  table: Table<FileItem>;
};

export function FilesListView({ isLoading, table }: FilesListViewProps) {
  const isEmpty = table.getRowModel().rows.length === 0;

  if (isLoading) {
    return (
      <div className="overflow-auto max-h-[calc(100dvh-310px)]">
        <div className="flex h-full w-full items-center justify-center text-text-secondary">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="overflow-auto max-h-[calc(100dvh-310px)]">
        <div className="flex h-full w-full items-center justify-center text-text-secondary">
          <span>This folder is empty. Upload files to get started.</span>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-auto max-h-[calc(100dvh-310px)]">
      <table className="w-full border-collapse table-fixed min-w-[768px]">
        <thead className="sticky top-0 bg-bg-primary z-10">
          <tr className="border-b border-border-secondary text-xs font-medium  text-text-tertiary">
            {table
              .getHeaderGroups()
              .map((headerGroup) =>
                headerGroup.headers.map((header) => (
                  <TableHeader header={header} key={header.id} />
                )),
              )}
            <th className="px-xl py-md" style={{ width: "50px" }}></th>
            {/* Fixed width for action menu */}
          </tr>
        </thead>
        <tbody className="relative overflow-y-auto">
          {table.getRowModel().rows.map((row) => (
            <TableRow
              key={row.id}
              resetRowSelection={table.resetRowSelection}
              resetSorting={table.resetSorting}
              row={row}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
